import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BasedataService} from '../shared/basedata.service';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {catchError, Observable} from 'rxjs';
import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {map} from 'rxjs/operators';

@Injectable()
export class ScribbleApiService extends BasedataService {

  constructor(private readonly httpClient: HttpClient,
              configService: ConfigService) {
    super(configService);
  }

  createScribbles(scribbles: ScribbleData[]): Observable<any> {
    const endpoint =  super.getFullUrl('/scribbles/bulk');
    return this.httpClient
      .post<any>(endpoint, JSON.stringify(scribbles), { headers: this.getHeaders() })
      .pipe(
        map(response => {
          const saved: { UniqueId: string, Id: number}[] = response.SavedScribbles;
          const savedScribbleLayer = response.SavedScribbleLayer;
          if (saved) {
            const scribblesDict = Object.fromEntries(scribbles.map(x => [x.UniqueId, x]));
            for (const s of saved) {
              if (scribblesDict[s.UniqueId]) {
                scribblesDict[s.UniqueId].Id = s.Id;
                if (savedScribbleLayer) {
                  scribblesDict[s.UniqueId].ScribbleLayer = savedScribbleLayer;
                }
              }
            }
          }

        }),

        catchError(e  => this.handleError(e)));
  }

  updateScribbles(scribbles: ScribbleData[]): Observable<any> {
    const endpoint =  super.getFullUrl('/scribbles/bulk');
    return this.httpClient
      .put<any>(endpoint, JSON.stringify(scribbles), { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  deleteScribbles(scribbles: ScribbleData[]): Observable<any> {
    const endpoint =  super.getFullUrl('/scribbles/bulk');
    return this.httpClient
      .delete<any>(endpoint, { body: JSON.stringify({ UniqueIds: scribbles.map(x => x.UniqueId)}), headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }
}
